'use strict';

const CACHES_SHAPE = require('./storage/CACHES_SHAPE');

module.exports = function lookupMeta (caches, typeOrRequest, ...idOrArgs) {
  const {
    timestamp,
    hasData,
    pending,
    error,
    cancelled,
    timeoutId,
    meta,
  } = CACHES_SHAPE.getAt(
    caches,
    typeOrRequest.referenceFor(...idOrArgs).storagePath()
  );
  return {
    timestamp,
    hasData,
    pending,
    error,
    cancelled,
    timeoutId,
    ...meta,
  };
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/lookupMeta.js